import {omit} from 'lodash'
import React from 'react'
import FormControl from '@mui/material/FormControl'
import InputAdornment from '@mui/material/InputAdornment'
import ClearIcon from '@mui/icons-material/Clear'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import MuiInput from '@mui/material/Input'
import InputLabel from '@mui/material/InputLabel'
import Select from '@mui/material/Select'
import {withStyles} from 'external/material'

const MenuProps = {
  PaperProps: {
    style: {
      marginTop: '1.5%'
    }
  }
};

const ClearableSelect = withStyles(theme => ({
  root: {
    "& .MuiInputLabel-formControl": {
      color: "#747b95",
      top: 8
    },
    "& .MuiSelect-select": {
      "&:focus": {
        backgroundColor: "transparent"
      }
    },
    "& .MuiInputBase-root": {
      border: 'solid 1px #bec4d2',
      borderRadius: '3px'
    },
    "& .Muiinput-underline:before": {
      borderBottom: "0 !important"
    },
    "& .MuiInputBase-input": {
      color: "#747b95",
      padding: "9px 42px 7px 5px !important"
    },
    "& .Mui-disabled": {
      opacity: 0.5,
      backgroundColor: '#f5f5f5'
    },
    "& .clear" : {
      position: 'absolute',
      right: '24px',
      cursor: 'pointer',
      "& svg": {
        fontSize: '13pt',
        color: "#747b95",
      }
    }
  }
}))(props => {

  const labelId = `${props.id}-label`
  return (
    <FormControl {...omit(props, ['notClearable'])} >
      <InputLabel id={labelId} className="label">{props.caption}</InputLabel>
      <Select
        labelId={labelId}
        id={props.id}
        className="select"
        variant={props.variant}
        onChange={props.onChange}
        value={props.value}
        input={props.notClearable ? undefined : <ClearableInput onClear={props.onClear || props.onChange} />}
        disabled={props.children.length > 0 ?  false : true}
      >
        {props.children}
      </Select>
    </FormControl>
  )
})

export {ClearableSelect as default}


function ClearableInput (props) {
  const clear = props.value == '' ? undefined : <Clear onClear={props.onClear} />
  return (<MuiInput {...omit(props, ['onClear'])} className="input" endAdornment={clear} />)
}

function Clear (props) {

   return (
     <InputAdornment onClick={props.onClear} className="clear" position="end" >
       <ClearIcon />
     </InputAdornment>
   )

}

